import React, { useState, useEffect } from 'react';
import styles from './AffiliateDeck.module.css';

const TOTAL = 20;
const SLIDE_BASE = '/affiliate-deck/slide-';

function slideSrc(n) {
    return `${SLIDE_BASE}${String(n).padStart(2, '0')}.webp`;
}

const FADE_MS = 160;

function AffiliateDeck() {
    const [current, setCurrent] = useState(0);
    const [visible, setVisible] = useState(true);
    const progress = ((current + 1) / TOTAL) * 100;

    const navigate = (next) => {
        setVisible(false);
        setTimeout(() => {
            setCurrent(next);
            setVisible(true);
        }, FADE_MS);
    };

    const goPrev = () => navigate(Math.max(0, current - 1));
    const goNext = () => navigate(Math.min(TOTAL - 1, current + 1));

    useEffect(() => {
        if (current > 0) {
            const prev = new Image();
            prev.src = slideSrc(current);
        }
        if (current < TOTAL - 1) {
            const next = new Image();
            next.src = slideSrc(current + 2);
        }
    }, [current]);

    return (
        <section className={styles.section}>
            <div className={styles.inner}>
                <p className={styles.sectionEyebrow}>THE FULL PITCH DECK</p>
                <div className={styles.viewer}>
                    <div className={styles.stage}>
                        <img
                            src={slideSrc(current + 1)}
                            alt={`Slide ${current + 1} of ${TOTAL}`}
                            className={styles.slideImg}
                            style={{ opacity: visible ? 1 : 0 }}
                            draggable={false}
                        />
                    </div>
                    <div className={styles.progressBar}>
                        <div className={styles.progressFill} style={{ width: `${progress}%` }} />
                    </div>
                    <div className={styles.controls}>
                        <button
                            className={styles.navBtn}
                            onClick={goPrev}
                            disabled={current === 0}
                            aria-label="Previous slide"
                        >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <polyline points="15 18 9 12 15 6" />
                            </svg>
                        </button>
                        <span className={styles.counter}>
                            {String(current + 1).padStart(2, '0')} / {String(TOTAL).padStart(2, '0')}
                        </span>
                        <button
                            className={styles.navBtn}
                            onClick={goNext}
                            disabled={current === TOTAL - 1}
                            aria-label="Next slide"
                        >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AffiliateDeck;
